const BASE_URL = `${process.env.REACT_APP_API_BOOKINGS_BASE_URL}/DiscountCode`;

const json = async (response) => {
  if (response.status >= 200 && response.status < 300) {
    if (response.status === 204) return null;
    const text = await response.text();
    return text ? JSON.parse(text) : null;
  }
  throw response;
};

export const getDiscountCodesForParkingArea = async (token, parkingAreaExtId) => {
  const response = await fetch(`${BASE_URL}/by-area/${parkingAreaExtId.toLowerCase()}`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`,
    },
  });
  return json(response);
};

export const getDiscountCodeByExtId = async (token, extId) => {
  const response = await fetch(`${BASE_URL}/${extId}`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`,
    },
  });
  return json(response);
};

export const getDiscountCodeUsages = async (token, extId) => {
  const response = await fetch(`${BASE_URL}/${extId}/usages`, {
    method: 'GET',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`,
    },
  });
  return json(response);
};

export const createDiscountCode = async (token, payload) => {
  const response = await fetch(`${BASE_URL}`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return json(response);
};

export const updateDiscountCode = async (token, extId, payload) => {
  const response = await fetch(`${BASE_URL}/${extId}`, {
    method: 'PATCH',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
  });
  return json(response);
};

export const softDeleteDiscountCode = async (token, extId) => {
  const response = await fetch(`${BASE_URL}/${extId}`, {
    method: 'DELETE',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`,
    },
  });
  return json(response);
};

export const restoreDiscountCode = async (token, extId) => {
  const response = await fetch(`${BASE_URL}/${extId}/restore`, {
    method: 'POST',
    headers: {
      'content-type': 'application/json',
      'authorization': `Bearer ${token}`,
    },
  });
  return json(response);
};
